module.exports = __webpack_public_path__ + "static/media/LoveDate.dff6d3ce.svg";